export default "__VITE_ASSET__BU9UZr5u__"